'use strict';

(function () {
    'use strict';

    // Usage:
    // 
    // Creates:
    // 

    TheLibraryWidgetController.$inject = ['$q', 'libraryService'];
    angular.module('app').component('theLibraryWidget', {
        template: '<div class="panel dashboard-panel {{$ctrl.cssClass}}" translate-namespace="library"><div class="panel-heading"><h2 translate>.Library</h2></div><div class="panel-body"><p translate-namespace="library" translate translate-values="$ctrl.library">.phrase:description</p></div><div class="panel-footer"><div class="text-right"><a ui-sref="library"><span translate-namespace="open-data" translate>.see more</span></a></div></div></div>',
        controller: TheLibraryWidgetController,
        controllerAs: '$ctrl',
        bindings: {
            cssClass: '@'
        }
    });

    function TheLibraryWidgetController($q, libraryService) {
        'ngInject';

        var $ctrl = this;

        ////////////////

        $ctrl.$onInit = function () {
            $q.all({
                library: libraryService.getLatestEntry()
            }).then(function (r) {
                $ctrl.library = _.assign(r.library, { 'semester': moment(r.library.date).month() === 1 ? 1 : 2 });
            });
        };

        $ctrl.$onChanges = function (changesObj) {};
        $ctrl.$onDestroy = function () {};
    }
})();